import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { getLanguage } from '../../store/rootReducer';
import { Language } from './services/constants';
import { connect } from 'react-redux';
import T from 'i18n-react';
import Lang from './services/Lang';

class HrbTranslate extends Component {

  getTranslationText = () => {
    if (this.props.language === Language.ENGLISH) {
      return this.props.en;
    } else {
      return this.props.fr;
    }
  };

  render() {
    let { text, params, language } = this.props;

    if (!text) {
      return (null);
    }

    text = Lang.getKey(text, language);

    return (
        <T.span id="hrb-translate-span" text={{key: text, ...params}} />
    );
  }
}

HrbTranslate.propTypes = {
  text: PropTypes.string,
  params: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  }
};

export default connect(
    mapStateToProps
)(HrbTranslate);

